import { createContext, useContext, useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import {
    Schedules_Add,
    Schedules_Get_All,
    Schedules_Get,
    Schedules_Get_ByUser,
    Schedules_Get_Pending_Initial,
    Schedules_Get_Pending_Final,
    Schedules_Update,
    Schedules_Approve_Initial,
    Schedules_Approve_Final,
    Schedules_Reject_Initial,
    Schedules_Reject_Final,
    Schedules_Conflict_Check,
    Schedules_Recommendation_Time_Get,
    Schedules_Recommendation_Room_Get,
    Schedules_Reschedule,
    Schedules_Relocate,
    Schedules_Edit
} from '../api/API_Schedules';
import {
    Logs_Reservation_Trail_Get
} from '../api/API_Reports'
import { useAuth } from "./AuthContext";
import { useAccounts } from "./Context_Accounts";
import { useStatus } from "./Context_Status_Global";
import { useMapRenderer } from "./Context_MapRenderer";
import { Context_UI } from "./Context_UI";

const Context_ScheduleManagement = createContext();

const Reservation_Default = {
    Name: "",
    Description: "",
    Requester: {
        Name: "",
        Email: "",
        RequesterID: "",
        Type: "No type selected"
    },
    Activity: {
        Type: "No activity type selected",
        Attendees: {
            Names: [],
            Count: 0
        },
        Subject: "-"
    },
    RoomID: "",
    Time: {
        Start: new Date(),
        End: new Date()
    },
    Equipment: [],
    Request_Airconditioner: false,
    Remarks: "No remarks given",
    DelegatedStaff: [],
    DateCreated: new Date(),
    DateModified: new Date(),
    Approval: {
        Initial: {
            State: "Pending",
            ApproverID: "Awaiting",
            DateApproved: new Date(),
            RejectionReason: ""
        },
        Final: {
            State: "Pending",
            ApproverID: "Awaiting",
            DateApproved: new Date(),
            RejectionReason: ""
        }
    }
}

export default function Context_Provider_ScheduleManagement({ children }) {
    const UI = useContext(Context_UI);
    const { User, User_Role, User_Permission } = useAccounts();
    const [Reservation, Reservation_Set] = useState(Reservation_Default);

    const [Reservation_Step, Reservation_Step_Set] = useState("Tab_Info_Request");

    const { Status_Saving_Set, Status_Fetching_Set, Confirmer_Confirm } = useStatus();

    const { List_Unsaved, List_Unsaved_Set } = useStatus();

    const { Map_Time_Parameters } = useMapRenderer();

    const Location = useLocation();

    const Reservation_Save = async () => {
        Status_Saving_Set("InProgress");
        try {
            await Schedules_Add(Reservation);
            Status_Saving_Set("Success");
            Schedules_Refresh();
            UI.Subwindows_Open("Window_ScheduleManagement_Reserve_Success");
        } catch (Error) {
            console.error(Error);
            Status_Saving_Set("Error");
        }
    }

    const Reservation_Clear = () => {
        Reservation_Set(Reservation_Default);
        Reservation_Step_Set("Tab_Info_Request");
        if (List_Unsaved.includes("Create Reservation")) {
            List_Unsaved_Set(prev => prev.filter(Item => Item !== "Create Reservation"));
        }
    }

    const [Schedules, Schedules_Set] = useState(null);
    const [Schedules_ByUser, Schedules_ByUser_Set] = useState([]);
    const [Schedules_Pending_Initial, Schedules_Pending_Initial_Set] = useState([]);
    const [Schedules_Pending_Final, Schedules_Pending_Final_Set] = useState([]);
    const [Version, Version_Set] = useState(0);

    useEffect(() => {
        Status_Fetching_Set("InProgress");
        Schedules_Get_All()
            .then(Results => {
                Schedules_Set(Results.data.Schedules_All);
                Schedules_ByUser_Set(Results.data.Schedules_ByUser);
                Schedules_Pending_Initial_Set(Results.data.Schedules_Pending_Initial);
                Schedules_Pending_Final_Set(Results.data.Schedules_Pending_Final);
                Status_Fetching_Set("Success");
                // if (Schedule_Information._id) {
                //     Schedule_Display(Schedule_Information._id);
                // }
            })
            .catch(Error => {
                Status_Fetching_Set("Error");
                console.error(Error);
            });
        /*Status_Fetching_Set("InProgress");
        Schedules_Get_ByUser()
            .then(Results => {
                Schedules_ByUser_Set(Results.data);
                Status_Fetching_Set("Success");
            })
            .catch(Error => {
                Status_Fetching_Set("Error");
                console.error(Error);
            });
        Status_Fetching_Set("InProgress");
        Schedules_Get_Pending_Initial()
            .then(Results => {
                Schedules_Pending_Initial_Set(Results.data);
                Status_Fetching_Set("Success");
            })
            .catch(Error => {
                Status_Fetching_Set("Error");
                console.error(Error);
            })
        Status_Fetching_Set("InProgress");
        Schedules_Get_Pending_Final()
            .then(Results => {
                Schedules_Pending_Final_Set(Results.data);
                Status_Fetching_Set("Success");
            })
            .catch(Error => {
                Status_Fetching_Set("Error");
                console.error(Error);
            })*/
    }, [Version]);



    const Schedules_Refresh = () => {
        Version_Set(prev => prev + 1);
    }

    const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const MONTHS = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    const MONTHS_SHORT = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];

    const pad2 = (n) => {
        return String(n).padStart(2, "0");
    }

    const toDateObject = (d) => {
        // accept Date or ISO string/number
        return (d instanceof Date) ? d : new Date(d);
    }

    const formatDateLong = (dateInput, component) => {
        const d = toDateObject(dateInput);
        const weekday = WEEKDAYS[d.getDay()];
        const day = d.getDate(); // no leading zero per your example
        const month = MONTHS[d.getMonth()];
        const month_short = MONTHS_SHORT[d.getMonth()];
        const year = d.getFullYear();
        if (!component) {
            return `${weekday}, ${day} ${month} ${year}`;
        } else if (component === "Month Year") {
            return `${month} ${year}`;
        } else if (component === "Shortened") {
            return `${day} ${month_short} ${year}`;
        }
    }

    const formatTime12 = (dateInput) => {
        const d = toDateObject(dateInput);
        let h = d.getHours();
        const m = pad2(d.getMinutes());
        const period = h >= 12 ? "PM" : "AM";
        h = h % 12 || 12; // convert 0 -> 12
        return `${h}:${m} ${period}`;
    }

    const Time_Range_Parse = (start, end, component) => {
        if (!component) {
            return `${formatDateLong(start)}; ${formatTime12(start)} - ${formatTime12(end)}`;
        } else if (component == "Date") {
            return `${formatDateLong(start)} - ${formatDateLong(end)}`;
        } else if (component == "Shortened") {
            return `${formatDateLong(start, "Shortened")} - ${formatDateLong(end, "Shortened")}`;
        } else if (component == "Time") {
            return `${formatTime12(start)} - ${formatTime12(end)}`;
        } else if (component == "Month Year") {
            return `${formatDateLong(start, "Month Year")} - ${formatDateLong(end, "Month Year")}`;
        }

    }

    const Time_Parse = (date, component) => {
        if (!component) {
            return `${formatDateLong(date)}; ${formatTime12(date)}`;
        } else if (component == "Date") {
            return `${formatDateLong(date)}`;
        } else if (component == "Shortened") {
            return `${formatDateLong(date, "Shortened")}`;
        } else if (component == "Time") {
            return `${formatTime12(date)}`;
        } else if (component == "Month Year") {
            return `${formatDateLong(date, "Month Year")}`;
        }

    }

    const Time_Overlap = (Schedule_Start, Schedule_End, Test_Start, Test_End) => {
        return (Schedule_Start < Test_End && Schedule_End > Test_Start);
    }

    // First, fix this function:
    const Time_BlockedHours_Overlap = (BlockedHours, Time) => {
        // Use the 'Time' parameter, not a global
        const Day_Current = new Date(Time).getDay();
        // console.warn(Day_Current);
        const Room = BlockedHours[Day_Current];
        // console.warn(Room);

        if (Room.Block) {
            return {
                Start: Room.Start,
                End: Room.End
            };
        } else {
            // Return null instead of undefined so we can check it
            return null;
        }
    }

    // ... Time_Overlap remains the same ...

    const Room_State_Get = (RoomID, DateValue, StartValue, EndValue, Room) => {
        if (!DateValue || !StartValue || !EndValue) return "No data";
        if (!Schedules) return "No data";

        // User's selected time
        const Start = new Date(`${DateValue}T${StartValue}`);
        const End = new Date(`${DateValue}T${EndValue}`);

        // --- FIX: Check for blocked hours FIRST ---
        if (Room && Room?.Restrictions?.hasBlockedHours) {
            // Get the blocked time for the selected day
            const BlockedTime = Time_BlockedHours_Overlap(Room.Restrictions.BlockedHours, DateValue);

            // Check if blocking is active for this day
            if (BlockedTime) {
                // console.warn("Blocked");
                // Convert blocked time strings to full Date objects
                const Block_Start = new Date(`${DateValue}T${BlockedTime.Start}`);
                const Block_End = new Date(`${DateValue}T${BlockedTime.End}`);

                // --- FIX: Compare Blocked Time vs. User's Time ---
                if (Time_Overlap(Block_Start, Block_End, Start, End)) {
                    return "Class hours";
                }
            }
        }

        // --- Now, check for conflicts with other schedules ---
        const Room_Schedules = Schedules.filter(s => s.RoomID === RoomID);

        for (let Schedule of Room_Schedules) {
            const Schedule_Start = new Date(Schedule.Time.Start);
            const Schedule_End = new Date(Schedule.Time.End);

            if (Time_Overlap(Schedule_Start, Schedule_End, Start, End)) {
                if (Schedule.Approval.Initial.State === "Pending" || Schedule.Approval.Final.State === "Pending") {
                    return "Pending";
                }
                if (Schedule.Approval.Initial.State === "Rejected" || Schedule.Approval.Final.State === "Rejected") {
                    return "Available"; // A rejected schedule doesn't block the time

                }
                return "Occupied";
            }
            // --- The check was removed from here ---
        }

        // If no blocked hours and no schedules matched, it's available
        return "Available";
    };

    const Room_Schedules_Get = (RoomID) => {
        if (!Schedules || !RoomID) return [];
        const Room_Schedules = Schedules.filter(s => s.RoomID === RoomID);
        return Room_Schedules;
    }

    const Room_Schedules_Current_Get = (RoomID, DateValue, StartValue, EndValue) => {
        if (!DateValue || !StartValue || !EndValue || !RoomID || !Schedules) return [];

        const Start = new Date(`${DateValue}T${StartValue}`);
        const End = new Date(`${DateValue}T${EndValue}`);

        const Room_Schedules = Schedules.filter(s => s.RoomID === RoomID);
        let Room_Schedules_Current = [];
        for (let Schedule of Room_Schedules) {
            const Schedule_Start = new Date(Schedule.Time.Start);
            const Schedule_End = new Date(Schedule.Time.End);

            if (Time_Overlap(Schedule_Start, Schedule_End, Start, End) && Schedule.Approval.Final.State === "Approved") {
                Room_Schedules_Current.push(Schedule);
            }
        }

        return Room_Schedules_Current;
    }


    const Schedule_inPast = (Schedule) => {
        if (Schedule?.Time?.Start) {
            const startDate = new Date(Schedule.Time.Start);
            const endDate = new Date(Schedule.Time.End);
            const now = new Date();

            if (endDate < now) {
                // Schedule has already ended
                return true;
            } else {
                return false;
            }
        }
    }

    const Status_Parse = (Schedule, Exclude_Expiry, Exclude_User) => {
        let Status = [];
        if (Schedule?.BlockedHours !== true) {
            if (User?._id === Schedule.Requester.RequesterID && !Exclude_User) {
                Status.push({
                    Text: "Made by you",
                    Color: "Purple"
                });
            }
            if (Schedule?.Time?.Start && !Exclude_Expiry) {
                const startDate = new Date(Schedule.Time.Start);
                const endDate = new Date(Schedule.Time.End);
                const now = new Date().setHours(0,0,0,0);

                const diffInMs = startDate - now;
                const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
                if (endDate < now) {
                    // Schedule has already ended
                    Status.push({
                        Text: "Past date",
                        Color: "Gray"
                    });
                } else if (diffInDays >= 0 && diffInDays <= 3) {
                    // Schedule is in the next 3 days
                    Status.push({
                        Text: "Upcoming soon",
                        Color: "Blue"
                    });
                } else if (diffInDays === 1) {
                    // Schedule is in the next 3 days
                    Status.push({
                        Text: "Today",
                        Color: "Blue"
                    });
                }
            }

            if (User_Permission?.Reservation?.Approve?.Initial || User_Permission?.Reservation?.Approve?.Final || User?._id === Schedule.Requester.RequesterID) {
                if (Schedule.Approval.Initial.State === "Pending") {
                    Status.push({
                        Text: "Pending from OSA",
                        Color: "Orange"
                    });
                } else if (Schedule.Approval.Initial.State === "Approved") {
                    Status.push({
                        Text: "Approved by OSA",
                        Color: "Green"
                    });
                } else if (Schedule.Approval.Initial.State === "Rejected") {
                    Status.push({
                        Text: "Rejected by OSA",
                        Color: "Red"
                    });
                    return Status;
                }

                if (Schedule.Approval.Final.State === "Pending") {
                    Status.push({
                        Text: "Pending from GSU",
                        Color: "Orange"
                    });
                } else if (Schedule.Approval.Final.State === "Approved") {
                    Status.push({
                        Text: "Approved by GSU",
                        Color: "Green"
                    });
                } else if (Schedule.Approval.Final.State === "Rejected") {
                    Status.push({
                        Text: "Rejected by GSU",
                        Color: "Red"
                    });
                }
            }

        } else {
            Status.push({
                Text: "Class hours",
                Color: "Orange"
            });
        }




        return Status;
    }

    const [Schedule_Information, Schedule_Information_Set] = useState(null);
    const [Schedule_Information_History, Schedule_Information_History_Set] = useState(null);

    const Schedule_Display = async (ID) => {
        Status_Fetching_Set("InProgress");
        await Schedules_Get(ID)
            .then(Result => {
                Schedule_Information_Set(Result.data);
                Status_Fetching_Set("Success");
            })
            .catch(Error => {
                Status_Fetching_Set("Error");
                console.error(Error);
            });
    }

    useEffect(() => {
        Schedule_Log_Display();
    }, [Schedule_Information])

    const Schedule_Log_Display = async () => {
        if (Schedule_Information?.Requester?.RequesterID === User?._id ||
            (User_Permission?.Reservation?.Approve?.Initial || User_Permission?.Reservation?.Approve?.Final) ||
            User_Permission?.Report?.ActivityLog
        ) {
            Status_Fetching_Set("InProgress");
            await Logs_Reservation_Trail_Get({ ID: Schedule_Information?._id })
                .then(Result => {
                    Schedule_Information_History_Set(Result.data);
                    Status_Fetching_Set("Success");
                })
                .catch(Error => {
                    Status_Fetching_Set("Error");
                    console.error(Error);
                });
        }
    }

    const [Schedule_Action_Mode, Schedule_Action_Mode_Set] = useState(null);

    const Reject_As = async (Type) => {
        Schedule_Action_Mode_Set(Type);
        const { Response, Data } = await Confirmer_Confirm('Window_ScheduleManagement_Reserve_Reject');
        if (Response === "Confirmed") {
            Status_Saving_Set("InProgress");
            if (Type === "OSA") {
                try {
                    await Schedules_Reject_Initial(Schedule_Information._id, { RejectionReason: Data.Value });
                    Status_Saving_Set("Success");
                    Schedule_Display(Schedule_Information._id);
                    Schedules_Refresh();
                } catch (Error) {
                    console.error(Error);
                    Status_Saving_Set("Error");
                }
            }
            if (Type === "GSU") {
                try {
                    await Schedules_Reject_Final(Schedule_Information._id, { RejectionReason: Data.Value });
                    Status_Saving_Set("Success");
                    Schedule_Display(Schedule_Information._id);
                    Schedules_Refresh();
                } catch (Error) {
                    console.error(Error);
                    Status_Saving_Set("Error");
                }
            }
            // Schedules_Refresh();
            // window.Toasts_CreateToast("https://bhimlex13.github.io/Student-Assistant-Portal/Assets/Icons/Logo.png", `${Data.Value}`, "");
        }
        // UI.Subwindows_Open("Window_ScheduleManagement_Reserve_Reject");
        // let Updated;

        // if (Type === "OSA") {
        //     Updated = {
        //         ...Schedule_Information,
        //         Approval: {
        //             ...Schedule_Information.Approval,
        //             Initial: {
        //                 State: "Rejected",
        //                 ApproverID: Account._id | "User",
        //                 DateApproved: new Date()
        //             }
        //         }
        //     };
        // }

        // if (Type === "GSU") {
        //     Updated = {
        //         ...Schedule_Information,
        //         Approval: {
        //             ...Schedule_Information.Approval,
        //             Final: {
        //                 State: "Rejected",
        //                 ApproverID: Account._id | "User",
        //                 DateApproved: new Date()
        //             }
        //         }
        //     };
        // }

        // Schedule_Information_Set(Updated);

        // try {
        //     Status_Saving_Set("InProgress");
        //     await Schedules_Update(Updated._id, Updated);
        //     Schedules_Refresh();
        //     Status_Saving_Set("Success");
        // } catch (err) {
        //     console.error(err);
        //     Status_Saving_Set("Error");
        // }
    };


    const Approve_As = async (Type) => {
        Schedule_Action_Mode_Set(Type);
        await Conflict_Check("Schedule_Information");
        if (Conflicts.Hard.length + Conflicts.Soft.length > 0) {
            const { Response, Data } = await Confirmer_Confirm('Window_ScheduleManagement_Reserve_Approve');
            if (Response === "Confirmed") {
                // console.log(Data);
                if (Type === "OSA") {
                    Status_Saving_Set("InProgress");
                    try {
                        // console.log(Schedule_Information._id);
                        await Schedules_Approve_Initial(Schedule_Information._id);
                        Schedules_Refresh();
                        Schedule_Display(Schedule_Information._id);
                        Status_Saving_Set("Success");
                    } catch (Error) {
                        console.error(Error);
                        Status_Saving_Set("Error");
                    }

                }
                if (Type === "GSU") {
                    Status_Saving_Set("InProgress");
                    try {
                        // console.log(Schedule_Information._id);
                        console.warn("Delegate");
                        UI.Subwindows_Open("Window_ScheduleManagement_Reserve_Approve_Delegate");
                        
                        // const { Response, Data } = await Confirmer_Confirm('Window_ScheduleManagement_Reserve_Approve_Delegate');
                        // if (Response === "Confirmed") {
                        //     await Schedules_Approve_Final(Schedule_Information._id, Data.DelegatedStaff);
                        // }
                        // Schedules_Refresh();
                        Status_Saving_Set("Success");
                    } catch (Error) {
                        console.error(Error);
                        Status_Saving_Set("Error");
                    }
                }
            }
        }

        if (Type === "OSA") {
            Status_Saving_Set("InProgress");
            try {
                // console.log(Schedule_Information._id);
                await Schedules_Approve_Initial(Schedule_Information._id);
                Schedule_Display(Schedule_Information._id);
                Schedules_Refresh();
                Status_Saving_Set("Success");
            } catch (Error) {
                console.error(Error);
                Status_Saving_Set("Error");
            }

        }
        if (Type === "GSU") {
            Status_Saving_Set("InProgress");
            try {
                // console.log(Schedule_Information._id);
                console.warn("Delegate");
                UI.Subwindows_Open("Window_ScheduleManagement_Reserve_Approve_Delegate");
                // console.log(Schedule_Information._id);
                // const { Response, Data } = await Confirmer_Confirm('Window_ScheduleManagement_Reserve_Approve_Delegate');
                // if (Response === "Confirmed") {
                //     console.log(Data.DelegatedStaff);
                //     await Schedules_Approve_Final(Schedule_Information._id, Data);
                // }
                // Schedules_Refresh();
                Status_Saving_Set("Success");
            } catch (Error) {
                console.error(Error);
                Status_Saving_Set("Error");
            }
        }


    }

    const Approve_Finally_As = async (Type, Data) => {
        if (Type === "OSA") {

        }
        if (Type === "GSU") {
            Status_Saving_Set("InProgress");
            UI.Subwindows_Close('Window_ScheduleManagement_Reserve_Approve_Delegate');
            try {
                // console.log("Attempting to save with ", Data);
                await Schedules_Approve_Final(Schedule_Information._id, Data);
                Schedule_Display(Schedule_Information._id);
                Schedules_Refresh();
                Status_Saving_Set("Success");
            } catch (Error) {
                console.error(Error);
                Status_Saving_Set("Error");
            }
            
        }
    }


    const Schedule_Reschedule = async (Type) => {
        const { Response, Data } = await Confirmer_Confirm('Window_ScheduleManagement_Schedule_Reschedule');
        if (Response === "Confirmed") {
            // console.log(Data);
            Status_Saving_Set("InProgress");
            try {
                const Payload = {
                    Time_Start: Data.Time_Start,
                    Time_End: Data.Time_End,
                    Reason: Data.Reason,
                    EditType: Type
                }
                const Result = await Schedules_Reschedule(Schedule_Information._id, Payload);
                Status_Saving_Set("Success");
                Schedules_Refresh();
                Schedule_Information_Set(Result.data);
                Conflict_Check("Schedule_Information");
            } catch (Error) {
                Status_Saving_Set("Error");
                console.error(Error)
            }
        }
    }

    const Schedule_Relocate = async (Type) => {
        const { Response, Data } = await Confirmer_Confirm('Window_ScheduleManagement_Schedule_Relocate');
        if (Response === "Confirmed") {
            // console.log(Data);
            Status_Saving_Set("InProgress");
            try {
                const Payload = {
                    RoomID: Data.RoomID,
                    Reason: Data.Reason,
                    EditType: Type
                }
                const Result = await Schedules_Relocate(Schedule_Information._id, Payload);
                Status_Saving_Set("Success");
                Schedules_Refresh();
                Schedule_Information_Set(Result.data);
                Conflict_Check("Schedule_Information");
            } catch (Error) {
                Status_Saving_Set("Error");
                console.error(Error)
            }
        }
    }

    const Schedule_Edit = async (Type) => {
        const { Response, Data } = await Confirmer_Confirm('Window_ScheduleManagement_Schedule_Edit');
        if (Response === "Confirmed") {
            // console.log(Data);
            Status_Saving_Set("InProgress");
            try {
                const Payload = {
                    Name: Data.Name,
                    Description: Data.Description,
                    Activity_Type: Data.Activity_Type,
                    Activity_Subject: Data.Activity_Subject,
                    Activity_Attendees: Data.Activity_Attendees,
                    Requester_Type: Data.Requester_Type,
                    Equipment: Data.Equipment,
                    Remarks: Data.Remarks,
                    Reason: Data.Reason,
                    EditType: Type
                }
                const Result = await Schedules_Edit(Schedule_Information._id, Payload);
                Status_Saving_Set("Success");
                Schedules_Refresh();
                Schedule_Information_Set(Result.data);
                Conflict_Check("Schedule_Information");
            } catch (Error) {
                Status_Saving_Set("Error");
                console.error(Error)
            }


        }
    }

    const [Conflicts, Conflicts_Set] = useState({ Soft: [], Hard: [] });
    const Conflict_Check = async (Type, Data) => {
        if (!Type) {
            const Payload = {
                RoomID: Reservation.RoomID,
                Time_Start: Reservation.Time.Start,
                Time_End: Reservation.Time.End
            }
            await Schedules_Conflict_Check(Payload)
                .then(Result => {
                    Conflicts_Set(Result.data);
                    // console.log(Result.data);
                })
                .catch(Error => {
                    console.error(Error);
                });
        } else if (Type == "Schedule_Information") {
            const Payload = {
                RoomID: Schedule_Information.RoomID,
                Time_Start: Schedule_Information.Time.Start,
                Time_End: Schedule_Information.Time.End,
                ScheduleID: Schedule_Information._id
            }
            await Schedules_Conflict_Check(Payload)
                .then(Result => {
                    Conflicts_Set(Result.data);
                    // console.log(Result.data);
                })
                .catch(Error => {
                    console.error(Error);
                });
        } else if (Type == "Temporary" && Data) {
            const Payload = {
                RoomID: Data.RoomID,
                Time_Start: Data.Time.Start,
                Time_End: Data.Time.End,
                ScheduleID: Data.ScheduleID
            }
            // console.warn(Payload);
            await Schedules_Conflict_Check(Payload)
                .then(Result => {
                    Conflicts_Set(Result.data);
                    // console.log(Result.data);
                })
                .catch(Error => {
                    console.error(Error);
                });
        }

    }

    const [Conflict_Recommendation, Conflict_Recommendation_Set] = useState({ Time: [], Room: [] });
    const Conflict_Recommendation_Get = async (Type) => {
        try {
            if (!Type) {
                const Payload = {
                    RoomID: Reservation.RoomID,
                    Time_Start: Reservation.Time.Start,
                    Time_End: Reservation.Time.End
                }
                const [Result_Time, Result_Room] = await Promise.all([
                    Schedules_Recommendation_Time_Get(Payload),
                    Schedules_Recommendation_Room_Get(Payload)
                ]);
                Conflict_Recommendation_Set({
                    Time: Result_Time.data.Time,
                    Room: Result_Room.data.Room
                });
            } else if (Type == "Schedule_Information") {
                const Payload = {
                    RoomID: Schedule_Information.RoomID,
                    Time_Start: Schedule_Information.Time.Start,
                    Time_End: Schedule_Information.Time.End
                }
                const [Result_Time, Result_Room] = await Promise.all([
                    Schedules_Recommendation_Time_Get(Payload),
                    Schedules_Recommendation_Room_Get(Payload)
                ]);
                Conflict_Recommendation_Set({
                    Time: Result_Time.data.Time,
                    Room: Result_Room.data.Room
                });
            }
        } catch (Error) {
            console.error(Error);
        }
        
    }

    useEffect(() => {
        if (Reservation_Step === "Tab_Info_Schedule") {
            Conflict_Check();
        }
    }, [Reservation.Time, Reservation.RoomID]);

    useEffect(() => {
        if (Location.pathname === "/schedules/reserve") {
            UI.Subwindows_Open("Window_ScheduleManagement_Reserve", "/schedules");
        }
    }, [Location.pathname]);


    return (
        <Context_ScheduleManagement.Provider value={{
            Reservation_Default,
            Reservation,
            Reservation_Set,
            Reservation_Save,
            Reservation_Step,
            Reservation_Step_Set,
            Reservation_Clear,
            Schedules_Refresh,
            Schedules,
            Schedules_ByUser,
            Schedules_Pending_Initial,
            Schedules_Pending_Final,
            Time_Range_Parse,
            Time_Parse,
            Room_State_Get,
            Room_Schedules_Get,
            Room_Schedules_Current_Get,
            Status_Parse,
            Schedule_Display,
            Schedule_Information,
            Schedule_Information_Set,
            Schedule_Information_History,
            Schedule_Information_History_Set,
            Schedule_Action_Mode,
            Reject_As,
            Approve_As,
            Approve_Finally_As,
            Conflicts,
            Conflict_Check,
            Conflict_Recommendation,
            Conflict_Recommendation_Get,
            Schedule_Reschedule,
            Schedule_Relocate,
            Schedule_Edit,
            Schedule_inPast
        }}>
            {children}
        </Context_ScheduleManagement.Provider>
    )
}


export function useScheduleManagement() {
    return useContext(Context_ScheduleManagement);
}